import { render, staticRenderFns } from "./TaskListEdit.vue?vue&type=template&id=5d768a45&scoped=true&"
import script from "./TaskListEdit.vue?vue&type=script&lang=js&"
export * from "./TaskListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d768a45",
  null
  
)

export default component.exports